var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUploadFile = function SvgUploadFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#uploadFile_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.111 4.667a.81.81 0 0 1-.808-.808V2.622a1.05 1.05 0 0 0-1.047-1.046H2.744a1.05 1.05 0 0 0-1.047 1.046V3.86a.808.808 0 0 1-1.616 0V2.622A2.667 2.667 0 0 1 2.744-.044h10.512a2.667 2.667 0 0 1 2.667 2.666V3.86a.807.807 0 0 1-.812.808"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 16a1.293 1.293 0 0 1-1.293-1.293V8.663a.167.167 0 0 0-.166-.166H4.768a.647.647 0 0 1-.488-1.071l3.232-3.717a.646.646 0 0 1 .976 0l3.232 3.717a.646.646 0 0 1-.488 1.07H9.459a.167.167 0 0 0-.166.167v6.044A1.293 1.293 0 0 1 8 16"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "uploadFile_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgUploadFile;